import { render, staticRenderFns } from "./Product1101001000012ogvtn.vue?vue&type=template&id=4a33c995"
import script from "./Product1101001000012ogvtn.vue?vue&type=script&lang=js"
export * from "./Product1101001000012ogvtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a33c995')) {
      api.createRecord('4a33c995', component.options)
    } else {
      api.reload('4a33c995', component.options)
    }
    module.hot.accept("./Product1101001000012ogvtn.vue?vue&type=template&id=4a33c995", function () {
      api.rerender('4a33c995', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product1101001000012ogvtn.vue"
export default component.exports